import type { StepType } from "@reactour/tour";
import TourStepContent from "./wrapper";
import { text } from "@quickpoint.me/shared";

const focusAndMotion: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => <strong>{text.tourSteps.a11yFocusHeading}</strong>}
			/>
		),
		position: "center",
	},
	{
		selector: "#tab-chat",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11yFocusIndicators}</strong>
						<br />
						<br />
						{text.tourSteps.a11yFocusDesc}
					</span>
				)}
			/>
		),
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11yReducedMotionHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11yReducedMotion}
					</span>
				)}
			/>
		),
		position: "center",
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11yHighContrastHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11yHighContrast}
						<br />
						<br />
						{text.tourSteps.a11yAutoAdapt}
					</span>
				)}
			/>
		),
		position: "center",
	},
];

export default focusAndMotion;
